module.exports = __webpack_public_path__ + "img/hook_KONDOTEC_LS_4.1018b214.png";